import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class Social extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return <div className="ltn__social-media">
			<ul>
				<li><a href="https://www.linkedin.com/in/medesco-immobilier-b05031371/" title="Linkdin"><i className="fa-linkedin-in fab" /></a></li>
				<li><a href="https://www.facebook.com/profile.php?id=61576828412186" title="Facebook"><i className="fab fa-facebook-f" /></a></li>
				<li><a href="https://www.instagram.com/medesco.immo/" title="Instagram"><i className="fab fa-instagram" /></a></li>
				<li><a href="https://www.tiktok.com/@medesco.immobilier" title="TikTok"><i className="fab fa-tiktok" /></a></li>
			</ul>
		</div>
        }
}

export default Social